<div class="hold-breakdown" *ngIf="data">
  <!-- Header: title + count badge, dismiss -->
  <div class="hold-breakdown__header">
    <div class="hold-breakdown__title-group">
      <span class="hold-breakdown__title">{{ data.title | translate }}</span>
      <!-- countLabel is already interpolated/resolved by the opener -->
      <span class="hold-breakdown__count">{{ data.countLabel }}</span>
    </div>
    <button
      type="button"
      class="hold-breakdown__close"
      [attr.aria-label]="'common.close' | translate"
      (click)="onDismiss()"
    >
      &times;
    </button>
  </div>

  <!-- Item rows -->
  <div class="hold-breakdown__list">
    <div class="hold-breakdown__row" *ngFor="let item of data.items">
      <div class="hold-breakdown__row-left">
        <span class="hold-breakdown__row-primary">{{ item.primary }}</span>
        <span class="hold-breakdown__row-secondary">{{ item.secondary }}</span>
      </div>
      <span class="hold-breakdown__row-amount">
        {{ item.amount | numberSuffix: { numberFormat: '1.2-2' } }}
      </span>
    </div>

    <div class="hold-breakdown__empty" *ngIf="!data.items || data.items.length === 0">
      {{ 'common.noRecord' | translate }}
    </div>
  </div>

  <!-- Outbound link. A <button>, not an <a> — this performs a client-side
       action (close + route), not a navigable href, and a plain href-less <a>
       gets caught by the global `a:not([href]) { color: inherit }` reset. -->
  <button type="button" class="hold-breakdown__link" (click)="onNavigate()">
    {{ data.linkLabel | translate }} &rarr;
  </button>
</div>
